import React from 'react';

import PropTypes from 'prop-types';
import CampaignIntrobox from '../CampaignIntrobox';
import classNames from 'classnames';
import { ucFirst } from '../../utils/caseconverters';
import styles from './CampaignEntry.module.scss';
import _ from 'lodash';

const CampaignEntry = ({
    infobox,
    richText,
    image = null,
    color = '',
    modifiers = [],
}) => {
    const {
        preamble,
        title,
        date,
        location,
        link: { href: linkHref, label: linkLabel },
    } = infobox;

    const hasIntroBox =
        !!preamble ||
        !!title ||
        !!date ||
        !!location ||
        !!linkHref ||
        !!linkLabel;

    let campaignClass = '';

    campaignClass = classNames(
        modifiers.map((mod) => styles['CampaignEntry--' + mod]),
        styles['CampaignEntry'],
        {
            [styles[`CampaignEntry--` + ucFirst(color)]]: color,
            [styles['CampaignEntry--noIntroBox']]: !hasIntroBox,
        }
    );

    return (
        <div className={campaignClass}>
            <div className={styles['CampaignEntry__Block']}>
                <div className={styles['CampaignEntry__LeftBlock']}>
                    <div
                        className={styles['CampaignEntry__RichText']}
                        dangerouslySetInnerHTML={{ __html: richText }}
                    />
                    {hasIntroBox && (
                        <CampaignIntrobox
                            preamble={preamble}
                            title={title}
                            date={date}
                            location={location}
                            linkHref={linkHref}
                            linkLabel={linkLabel}
                        />
                    )}
                </div>
                <div className={styles['CampaignEntry__RightBlock']}>
                    {image.renditions && (
                        <figure
                            className={styles['CampaignEntry__ImageContainer']}>
                            <img
                                className={styles['CampaignEntry__Image']}
                                sizes="100vw"
                                srcSet={`${image.renditions.large.src} 1200w,
                                    ${image.renditions.medium.src} 600w`}
                                src={image.renditions.small.src}
                                alt={`${image.alt}`}
                            />
                        </figure>
                    )}
                </div>
            </div>
        </div>
    );
};

CampaignEntry.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    modifiers: PropTypes.array,
    image: PropTypes.object,
};

export default CampaignEntry;
